import { createTypedHooks } from 'easy-peasy';

import type { storeModel } from './models';

export const { useStoreActions, useStoreState, useStoreDispatch, useStore } =
  createTypedHooks<typeof storeModel>();
